<div class="login-container" nz-row>

  <div nz-col nzSm="0" nzMd="12" class="login-background">
  </div>
  <div nz-col nzSm="24" nzMd="12" class="login-inputs-container">
  <div class="top-section">
      <div class="language-wrapper">
        <nz-select class="language-select" style="width:100%;"
          [(ngModel)]="selectedLanguage" (ngModelChange)="changeLanguage($event)">
          <nz-option nzValue="en" nzLabel="English"></nz-option>
          <nz-option nzValue="fr" nzLabel="Français"></nz-option>
          <nz-option nzValue="es" nzLabel="Español"></nz-option>
          <nz-option nzValue="de" nzLabel="Deutsch"></nz-option>
        </nz-select>
      </div>
    </div>

    <div class="login-inputs bottom-section">
 


      <div>
        <img class="logo-image" src="/assets/logo-shape.svg" alt="ITM-LOGO" />
      </div>
      <div>
        <img class="logo-text" src="/assets/logo-text.svg" alt="ITM-TEXT" />
      </div>
      <ng-content></ng-content>
      <div class="footer">
        <p>{{'Want to know more about ITM PIM 360' | translate | locale }}</p>
        <p>
          {{ 'or our other solutions visit:' | translate | locale }}
          <a href="https://www.itm-development.com">itm-development.com</a>
        </p>
      </div>
      
    </div>
  </div>
</div>